import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-media gfu-media--middle gfu-field-document__preview"
}
const _hoisted_2 = { class: "gfu-field-document__icon _mr-2" }
const _hoisted_3 = { class: "gfu-media__body _flex _ai-c _jc-sb _fo _wb-ba" }
const _hoisted_4 = {
  key: 1,
  class: "_fo"
}
const _hoisted_5 = {
  key: 2,
  class: "_ml-2 _tc--accent _shrink-0"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "gfu-field-document__icon gfu-field-document__primary _mr-2" }
const _hoisted_9 = { class: "gfu-media__body" }
const _hoisted_10 = { class: "gfu-bt gfu-bt--caption _tc--gray" }
const _hoisted_11 = ["id", "name", "accept", "value", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_external_link = _resolveComponent("external-link")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([
                 'gfu-field-document',
                 {'is-dragover': _ctx.isDragover},
                 {'is-readonly': $props.readOnly},
             ]),
        onDragover: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onDragOver && $options.onDragOver(...args)), ["prevent"])),
        onDragleave: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onDragLeave && $options.onDragLeave(...args)), ["prevent"])),
        onDrop: _cache[3] || (_cache[3] = (...args) => ($options.onDrop && $options.onDrop(...args)))
      }, [
        ($options.previewMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_icon, {
                  name: $options.fileIconName,
                  size: "lg",
                  class: "_tc--accent"
                }, null, 8 /* PROPS */, ["name"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                ($options.fileUrl)
                  ? (_openBlock(), _createBlock(_component_external_link, {
                      key: 0,
                      href: $options.fileUrl,
                      class: "_fo",
                      onClick: _withModifiers($options.onFileNameClick, ["prevent"]),
                      "data-qa": "document-field-preview:Url"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.fileName), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href", "onClick"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.fileName), 1 /* TEXT */)),
                (!$props.readOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("label", { for: $props.id }, [
                        _createVNode(_component_base_icon, {
                          name: "sync",
                          size: "lg",
                          class: "_cur-p",
                          "data-qa": "replace-document"
                        })
                      ], 8 /* PROPS */, _hoisted_6),
                      _createVNode(_component_base_icon, {
                        name: "times",
                        size: "lg",
                        class: "_ml-2 _cur-p",
                        onClick: $options.onReset,
                        "data-qa": "remove-document"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("label", {
              key: 1,
              class: "gfu-media gfu-media--middle gfu-field-document__upload _cur-p",
              for: $props.id,
              "data-qa": "document-field"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_base_icon, {
                  name: "upload",
                  size: "lg"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "_tc--base" }, [
                  _createElementVNode("strong", null, "Drop your file here or select from disk.")
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_10, [
                  _renderSlot(_ctx.$slots, "caption", {}, () => [
                    _createTextVNode(" Accepted formats are " + _toDisplayString($options.acceptFileLabels) + "." + _toDisplayString($props.minSize ? ` Minimum allowed file size is ${$options.formatFileSize($props.minSize)}.` : '') + " Maximum allowed file size is " + _toDisplayString($options.formatFileSize($props.maxSize)) + ". ", 1 /* TEXT */)
                  ])
                ])
              ])
            ], 8 /* PROPS */, _hoisted_7)),
        _createElementVNode("input", {
          id: $props.id,
          ref: "file",
          name: $props.name,
          type: "file",
          class: _normalizeClass(['gfu-field-document__input']),
          accept: $props.accept,
          value: _ctx.file,
          onChange: _cache[0] || (_cache[0] = (...args) => ($options.onFileChange && $options.onFileChange(...args))),
          "data-qa": `documentField:${$props.name}`
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_11)
      ], 34 /* CLASS, NEED_HYDRATION */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}